import { Rbac } from '../../../common/Rbac';
import { RbacObject } from '../../../../export-types/cleaned-types';
import { toast } from 'react-toastify';
import React from 'react';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { trpc, RouterInput } from '../../../../api/trpc';
import { ModalsService } from '../../../../services/modals.service';
import { ConfirmModal } from '../../../common/confirm-modal';
import { CustomsDeliverySentToRevisionModal } from './customs-delivery-sent-to-revision-modal';

export const AdminCustomsDeliveryOrderActionsBlock = ({
  id,
}: {
  id: string;
}) => {
  const input = { id: id };
  const { data: order, mutate } = useSWR(
    ['customsDelivery.getOne', input],
    () => trpc.customsDelivery.getOne.query(input),
  );

  const { trigger: updateStatus } = useSWRMutation(
    ['customsDelivery.updateStatus'],
    (_k, { arg }: { arg: RouterInput['customsDelivery']['updateStatus'] }) =>
      trpc.customsDelivery.updateStatus.mutate(arg),
    {
      onError: (e: any) => {
        toast.error(e.message);
      },
      onSuccess: () => {
        mutate();
      },
    },
  );
  const { trigger: revertStatus } = useSWRMutation(
    ['customsDelivery.revertStatus'],
    (_k, { arg }: { arg: RouterInput['customsDelivery']['revertStatus'] }) =>
      trpc.customsDelivery.revertStatus.mutate(arg),
    {
      onError: (e: any) => {
        toast.error(e.message);
      },
      onSuccess: () => {
        mutate();
      },
    },
  );
  const { trigger: revertToPreparing } = useSWRMutation(
    ['customsDelivery.revertToPreparing'],
    (
      _k,
      { arg }: { arg: RouterInput['customsDelivery']['revertToPreparing'] },
    ) => trpc.customsDelivery.revertToPreparing.mutate(arg),
    {
      onError: (e: any) => {
        toast.error(e.message);
      },
      onSuccess: () => {
        mutate();
      },
    },
  );
  if (!order) {
    return null;
  }

  return (
    <div className="flex d-flex mb-3 justify-content-center">
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'created' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перевести в "Новый"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'preparing',
                  }),
                );
              }}
            >
              Перевести в "Новый"
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'preparing' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Взять в работу?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'codeSelected',
                  }),
                );
              }}
            >
              Взять в работу
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'codeSelected' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Подобраны все коды ТН ВЭД?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'calculationReady',
                  }),
                );
              }}
            >
              Код подобран
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'calculationReady' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Отправить расчёт клиенту?`,
                  buttonText: `Отправить`,
                }).then(() => {
                  updateStatus({
                    id: order.id,
                    status: 'protectCalculation',
                  });
                });
              }}
            >
              Расчет сделан
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'protectCalculation' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Передать на подготовку документов?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'prepareDocs',
                  }),
                );
              }}
            >
              Передать на подготовку документов
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'prepareDocs' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Документ отправлен?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'declarant',
                  }),
                );
              }}
            >
              Документ отправлен
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'declarant' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Подтверждено декларантом?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'prepareInvoice',
                  }),
                );
              }}
            >
              Подтвержден декларантом
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'declarant' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-danger"
              onClick={async () => {
                await ModalsService.createModal(
                  CustomsDeliverySentToRevisionModal,
                  {
                    orderId: id,
                  },
                ).then(() => mutate());
              }}
            >
              Отправить на доработку
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'prepareInvoice' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Отправить счет?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'waitingForPayment',
                  }),
                );
              }}
            >
              Счет отправлен
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'waitingForPayment' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перевести на статус "Выкупить"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'buyOut',
                  }),
                );
              }}
            >
              Перевести на статус "Выкупить"
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'buyOut' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перевести на статус "В пути"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'inWork',
                  }),
                );
              }}
            >
              Перевести на статус "В пути"
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'inWork' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перевести на статус "На складе"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({
                    id: order.id,
                    status: 'inStock',
                  }),
                );
              }}
            >
              Перевести на статус "На складе"
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'inStock' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Отправить в РФ`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'sentToRussia' }),
                );
              }}
            >
              Отправить в РФ
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'sentToRussia' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перенести на статус "Таможня"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'customs' }),
                );
              }}
            >
              Таможня
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'customs' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перенести на статус "Транзитный склад"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'transitWarehouse' }),
                );
              }}
            >
              Транзитный склад
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'transitWarehouse' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Передать в ТК?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'transferredToTC' }),
                );
              }}
            >
              Передать в ТК
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'transferredToTC' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-success"
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перенести в "Полученные"?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'received' }),
                );
              }}
            >
              Получить
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status !== 'created' && order.status !== 'archived' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-light "
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Вернуть на предыдущий статус?`,
                  buttonText: `Готово`,
                }).then(() => revertStatus({ id: order.id }));
              }}
            >
              Назад
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status !== 'archived' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-light "
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Перенести в архив?`,
                  buttonText: `Готово`,
                }).then(() =>
                  updateStatus({ id: order.id, status: 'archived' }),
                );
              }}
            >
              В архив
            </div>
          </div>
        )}
      </Rbac>
      <Rbac object={RbacObject.CustomsDelivery} action={['write']}>
        {order.status === 'archived' && (
          <div className="mx-1 d-flex flex-row justify-content-center">
            <div
              className="btn btn-light "
              onClick={async () => {
                await ModalsService.createModal(ConfirmModal, {
                  title: `Вернуть в работу?`,
                  buttonText: `Готово`,
                }).then(() => revertToPreparing({ id: order.id }));
              }}
            >
              Вернуть в работу
            </div>
          </div>
        )}
      </Rbac>
    </div>
  );
};
